import { Box, Tooltip, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

interface TagChipProps {
  label: string;
  /** Acima deste tamanho trunca com tooltip (comportamento herdado da tabela antiga) */
  maxChars?: number;
}

/** Chip creme de tag de paciente */
export default function TagChip({ label, maxChars = 15 }: TagChipProps) {
  const theme = useTheme();
  const truncated = label.length > maxChars ? `${label.slice(0, maxChars)}...` : label;

  const chip = (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: "10px",
        py: "3px",
        borderRadius: "100px",
        fontSize: "11px",
        fontWeight: 500,
        color: "primary.dark",
        backgroundColor: theme.palette.brand.cream,
        border: `1px solid ${theme.palette.brand.heroBorder}`,
        whiteSpace: "nowrap",
      }}
    >
      {truncated}
    </Box>
  );

  return label.length > maxChars ? <Tooltip title={label}>{chip}</Tooltip> : chip;
}
